import { Injectable } from '@angular/core';
import { HttpService } from 'app/resources/services/http.service';
import { LoginService } from 'app/resources/services/login.service';

@Injectable()
export class ParceiroService {

  public parceirosLoja: any = undefined;
  public parceirosValePresente: any = undefined;

  constructor(public http: HttpService, public loginService: LoginService) { }

  public fillAtivosLoja() {
    this.http.pathRest().get('parceiros/produto/ativo/', true)
      .subscribe(
        sucesso => {
          this.parceirosLoja = sucesso.json();
        });
  }

  public fillAtivosValePresente() {
    this.http.pathRest().get('parceiros/valepresente/vitrine/', true)
      .subscribe(
        sucesso => {
          this.parceirosValePresente = sucesso.json();
        });
  }

  public getParceirosLoja() {
    return this.parceirosLoja;
  }

  public getParceirosValePresente() {
    return this.parceirosValePresente;
  }

  public activate() {
    if (this.loginService.permissionService.hasPermission('funcionalidade:vale_presente')) {
      this.fillAtivosValePresente();
    }
    if (this.loginService.permissionService.hasPermission('funcionalidade:loja')) {
      this.fillAtivosLoja();
    }
  }

  public clean() {
    this.parceirosLoja = undefined;
    this.parceirosValePresente = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/parceiro.service.ts